import { render, staticRenderFns } from "./AdminFilterDuration.vue?vue&type=template&id=40085474&scoped=true"
import script from "./AdminFilterDuration.vue?vue&type=script&lang=js"
export * from "./AdminFilterDuration.vue?vue&type=script&lang=js"
import style0 from "./AdminFilterDuration.vue?vue&type=style&index=0&id=40085474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40085474",
  null
  
)

export default component.exports